import { SelectItem } from 'primeng/primeng';
export class TransitionList {

  public transitonsIn: SelectItem[] = [];
  public transitonsOut: SelectItem[] = [];

  constructor() {
    this.transitonsIn.push({ label: 'None', value: '' });
    this.transitonsIn.push({ label: 'fadeIn', value: 'fadeIn' });
    this.transitonsIn.push({ label: 'fadeInDown', value: 'fadeInDown' });
    this.transitonsIn.push({ label: 'fadeInDownBig', value: 'fadeInDownBig' });
    this.transitonsIn.push({ label: 'fadeInLeft', value: 'fadeInLeft' });
    this.transitonsIn.push({ label: 'fadeInLeftBig', value: 'fadeInLeftBig' });
    this.transitonsIn.push({ label: 'fadeInRight', value: 'fadeInRight' });
    this.transitonsIn.push({ label: 'fadeInRightBig', value: 'fadeInRightBig' });
    this.transitonsIn.push({ label: 'fadeInUp', value: 'fadeInUp' });
    this.transitonsIn.push({ label: 'fadeInUpBig', value: 'fadeInUpBig' });
    this.transitonsIn.push({ label: 'slideInDown', value: 'slideInDown' });
    this.transitonsIn.push({ label: 'slideInLeft', value: 'slideInLeft' });
    this.transitonsIn.push({ label: 'slideInRight', value: 'slideInRight' });
    this.transitonsIn.push({ label: 'slideInUp', value: 'slideInUp' });
    this.transitonsIn.push({ label: 'bounce', value: 'bounce' });
    this.transitonsIn.push({ label: 'flash', value: 'flash' });
    this.transitonsIn.push({ label: 'pulse', value: 'pulse' });
    this.transitonsIn.push({ label: 'rubberBand', value: 'rubberBand' });
    this.transitonsIn.push({ label: 'shake', value: 'shake' });
    this.transitonsIn.push({ label: 'headShake', value: 'headShake' });
    this.transitonsIn.push({ label: 'swing', value: 'swing' });
    this.transitonsIn.push({ label: 'tada', value: 'tada' });
    this.transitonsIn.push({ label: 'wobble', value: 'wobble' });
    this.transitonsIn.push({ label: 'jello', value: 'jello' });
    this.transitonsIn.push({ label: 'bounceIn', value: 'bounceIn' });
    this.transitonsIn.push({ label: 'bounceInDown', value: 'bounceInDown' });
    this.transitonsIn.push({ label: 'bounceInLeft', value: 'bounceInLeft' });
    this.transitonsIn.push({ label: 'bounceInRight', value: 'bounceInRight' });
    this.transitonsIn.push({ label: 'bounceInUp', value: 'bounceInUp' });
    this.transitonsIn.push({ label: 'flipInX', value: 'flipInX' });
    this.transitonsIn.push({ label: 'flipInY', value: 'flipInY' });
    this.transitonsIn.push({ label: 'lightSpeedIn', value: 'lightSpeedIn' });
    this.transitonsIn.push({ label: 'rotateIn', value: 'rotateIn' });
    this.transitonsIn.push({ label: 'rotateInDownLeft', value: 'rotateInDownLeft' });
    this.transitonsIn.push({ label: 'rotateInDownRight', value: 'rotateInDownRight' });
    this.transitonsIn.push({ label: 'rotateInUpLeft', value: 'rotateInUpLeft' });
    this.transitonsIn.push({ label: 'rotateInUpRight', value: 'rotateInUpRight' });
    this.transitonsIn.push({ label: 'zoomIn', value: 'zoomIn' });
    this.transitonsIn.push({ label: 'zoomInDown', value: 'zoomInDown' });
    this.transitonsIn.push({ label: 'zoomInLeft', value: 'zoomInLeft' });
    this.transitonsIn.push({ label: 'zoomInRight', value: 'zoomInRight' });
    this.transitonsIn.push({ label: 'zoomInUp', value: 'zoomInUp' });
    this.transitonsIn.push({ label: 'rollIn', value: 'rollIn' });



    this.transitonsOut.push({ label: 'bounceOut', value: 'bounceOut' });
    this.transitonsOut.push({ label: 'bounceOutDown', value: 'bounceOutDown' });
    this.transitonsOut.push({ label: 'bounceOutLeft', value: 'bounceOutLeft' });
    this.transitonsOut.push({ label: 'bounceOutRight', value: 'bounceOutRight' });
    this.transitonsOut.push({ label: 'bounceOutUp', value: 'bounceOutUp' });
    this.transitonsOut.push({ label: 'fadeOut', value: 'fadeOut' });
    this.transitonsOut.push({ label: 'fadeOutDown', value: 'fadeOutDown' });
    this.transitonsOut.push({ label: 'fadeOutDownBig', value: 'fadeOutDownBig' });
    this.transitonsOut.push({ label: 'fadeOutLeft', value: 'fadeOutLeft' });
    this.transitonsOut.push({ label: 'fadeOutLeftBig', value: 'fadeOutLeftBig' });
    this.transitonsOut.push({ label: 'fadeOutRight', value: 'fadeOutRight' });
    this.transitonsOut.push({ label: 'fadeOutRightBig', value: 'fadeOutRightBig' });
    this.transitonsOut.push({ label: 'fadeOutUp', value: 'fadeOutUp' });
    this.transitonsOut.push({ label: 'fadeOutUpBig', value: 'fadeOutUpBig' });
    this.transitonsOut.push({ label: 'lightSpeedOut', value: 'lightSpeedOut' });
    this.transitonsOut.push({ label: 'rotateOut', value: 'rotateOut' });
    this.transitonsOut.push({ label: 'rotateOutDownLeft', value: 'rotateOutDownLeft' });
    this.transitonsOut.push({ label: 'rotateOutDownRight', value: 'rotateOutDownRight' });
    this.transitonsOut.push({ label: 'rotateOutUpLeft', value: 'rotateOutUpLeft' });
    this.transitonsOut.push({ label: 'rotateOutUpRight', value: 'rotateOutUpRight' });
    this.transitonsOut.push({ label: 'hinge', value: 'hinge' });
    this.transitonsOut.push({ label: 'rollOut', value: 'rollOut' });
    this.transitonsOut.push({ label: 'zoomOut', value: 'zoomOut' });
    this.transitonsOut.push({ label: 'zoomOutDown', value: 'zoomOutDown' });
    this.transitonsOut.push({ label: 'zoomOutLeft', value: 'zoomOutLeft' });
    this.transitonsOut.push({ label: 'zoomOutRight', value: 'zoomOutRight' });
    this.transitonsOut.push({ label: 'zoomOutUp', value: 'zoomOutUp' });
    this.transitonsOut.push({ label: 'slideOutDown', value: 'slideOutDown' });
    this.transitonsOut.push({ label: 'slideOutLeft', value: 'slideOutLeft' });
    this.transitonsOut.push({ label: 'slideOutRight', value: 'slideOutRight' });
    this.transitonsOut.push({ label: 'slideOutUp', value: 'slideOutUp' });
    this.transitonsOut.push({ label: 'flipOutX', value: 'flipOutX' });
    this.transitonsOut.push({ label: 'flipOutY', value: 'flipOutY' });
  }

}



// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/scheduling/components/rotationitem-listitem/transitionList.class.ts